export default "__VITE_ASSET__Bj7PeKml__"